// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__3PTSQ","Success":"Button_Success__-wmuj","Danger":"Button_Danger__3nPUQ"};